import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormArray } from '@angular/forms';
import { RealEstateUopOption } from '../../models/real-estate-project.model';
import { RealEstateService } from '../../services/real-estate.service';
@Component({
  selector: 'app-real-estate-project-uop',
  templateUrl: './real-estate-project-uop.component.html',
  styleUrls: ['./real-estate-project-uop.component.scss'],
  standalone: false,
})
export class RealEstateProjectUopComponent implements OnInit, OnChanges {
  @Input() reviewMode: boolean = false;
  @Input() realEstateUopForm!: FormGroup;

  uopOptions: RealEstateUopOption[] = [];
  filteredUopDescriptions: Record<number, RealEstateUopOption[]> = {};
  uopSearchControl: FormControl = new FormControl('');
  uopProject: FormControl = new FormControl('');
  uopDesc: FormControl = new FormControl('');
  uopInstallMaterial: FormControl = new FormControl('');
  uopInstallLabor: FormControl = new FormControl('');
  uopRemovalLabor: FormControl = new FormControl('');
  uopVintageYear: FormControl = new FormControl('');

  constructor(
    private fb: FormBuilder,
    private realEstateService: RealEstateService
  ) {}

  ngOnInit() {
    this.getUopOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle reviewMode changes
    if (this.realEstateUopForm && changes['reviewMode']) {
      if (this.reviewMode) {
        this.realEstateUopForm.disable();
      } else {
        this.realEstateUopForm.enable();
      }
    }
  }

  getUopOptions(): void {
    this.realEstateService.getUopData().subscribe(
      (response) => {
        this.uopOptions = response || [];
        if (this.reviewMode) {
          this.realEstateUopForm.value.uopDetails.forEach((_, index: number) => {
            this.filteredUopDescriptions[index] = this.uopOptions;
          });
        }
      },
      (error) => {
        console.error('Error fetching UOP options:', error);
      }
    );
  }

  filterUopDesc(index: number): void {
    const searchValue = this.uopSearchControl.value.toLowerCase();
    // Filter the uopOptions based on the search value
    this.filteredUopDescriptions[index] = this.uopOptions.filter((uop) =>
      uop.unit_of_property.toLowerCase().includes(searchValue)
    );
  }

  get uopDetails(): FormArray {
    return <FormArray>this.realEstateUopForm.get('uopDetails');
  }

  addUopOption() {
    this.uopDetails.push(
      this.fb.group({
        uopProject: [''],
        uopDesc: [''],
        uopInstallMaterial: [''],
        uopInstallLabor: [''],
        uopRemovalLabor: [''],
        uopVintageYear: [''],
      })
    );
    this.filteredUopDescriptions[this.uopDetails.length - 1] = [...this.uopOptions];
  }

  deleteUopOption(index) {
    this.uopDetails.removeAt(index);
    this.filteredUopDescriptions[index] = [...this.uopOptions];
  }

  getTotalUopCost(): number {
    return this.uopDetails.controls.reduce((total, group) => {
      const material =
        Number(group.get('uopInstallMaterial') && group.get('uopInstallMaterial').value) || 0;
      const labor = Number(group.get('uopInstallLabor') && group.get('uopInstallLabor').value) || 0;
      const removal =
        Number(group.get('uopRemovalLabor') && group.get('uopRemovalLabor').value) || 0;
      return total + material + labor + removal;
    }, 0);
  }

  formatVintageYear(event: any, index: number): void {
    const input = event.target.value.replace(/[^\d]/g, ''); // Remove all non-digits
    let formatted = '';

    if (input.length > 0) {
      // First part (vintage year) - up to 4 digits
      formatted = input.substring(0, 4);

      // Add separator and second part (useful life) - up to 2 digits
      if (input.length > 4) {
        formatted += ' / ' + input.substring(4, 6);
      }
    }

    // Update the form control value
    const control = this.uopDetails.at(index).get('uopVintageYear');
    if (control) {
      control.setValue(formatted, { emitEvent: false });
    }
  }
}
